<template>
    <paper class="performance-waybill-manage-wrapper">
        <div style="color:red; font-size:13px; height:24px">因审计合规需要，平台需对涉及用户隐私的关键字段（包括但不限于姓名、身份证号、手机号、详细地址等）进行统一脱敏处理。</div>
        <m-pane
            ref="tablePage"
            :virtual="true"
            :config="config"
            :pageTotal="pageTotal"
            :loading="loading"
            :totalData="totalData"
            :pickerConfig="timeRangeShortcuts"
            :searchTotalTitle="config.searchTotalTitle"
            :currentPage="searchParams.pageNo"
            :extraFixedHeight="24"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @row-db-click="rowDBclick"
            @btnClick="btnClick"
            @viewDetail-btn="viewWaybillDetail"
            @viewTrack-btn="viewTrack"
            @printLog-btn="printLog"
            @onReveal-btn="onReveal"
        >
            <span slot="search-list-advance-last">
                <el-dropdown style="margin-left: 8px">
                    <el-button type="primary">
                        标签<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="handleAddLabel">新建标签</el-dropdown-item>
                        <el-dropdown-item @click.native="handleLabelManage">标签管理</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </span>
            <div slot="table-module-btn">
                <template v-if="showEye">
                    <el-tooltip effect="dark" content="整页解密" placement="bottom">
                        <el-button icon="el-icon-view" size="mini" :disabled="pageTotal === 0" @click="onRevealAll"></el-button>
                    </el-tooltip>
                </template>
                <reportExport #default="{ submit }" reportCode="TMS_TRANSPORT_CENTER">
                    <el-tooltip effect="dark" content="导出" placement="bottom">
                        <span class="mgl-10">
                            <el-button
                                icon="icon-daochu"
                                size="mini"
                                :disabled="pageTotal === 0"
                                @click="exportFile(submit)"
                            ></el-button>
                        </span>
                    </el-tooltip>
                </reportExport>
            </div>
            <div slot="page-module-btn">
                <!-- 迁至移交中心 -->
                <!-- <el-button type="primary" @click="handleCreateTransferOrder">
                    移交单创建
                </el-button> -->
                <!-- <el-button
                    type="primary"
                    @click="pullOtpLoadingData"
                    :loading="pullBtnLoading"
                    v-has="'150201002'"
                    >拉取OTP装货数据</el-button
                >
                <el-button
                    type="primary"
                    @click="bindLdWaybillNo"
                    :loading="bindLoading"
                    v-has="'150201004'"
                    >绑定零担运单号</el-button
                >
                <el-button
                    type="primary"
                    @click="handlePrint"
                    v-has="'150201005'"
                    >打 印</el-button
                > -->
            </div>
        </m-pane>
        <!-- 移交单创建 -->
        <transfer-create
            v-if="transferDialogVisible"
            :dialogVisible.sync="transferDialogVisible"
            :transferCreatResponseList="selected"
            @close="handleClose"
        ></transfer-create>
        <!-- 绑定零担运单号 -->
        <bind-waybill
            v-if="bindDialogVisible"
            :bindDialogVisible.sync="bindDialogVisible"
            :selectedData="selected"
            @close="handleCloseBindDialog"
        ></bind-waybill>
        <!-- 新建标签弹窗 -->
        <add-label-dialog
            v-if="isShowAddLabel"
            ref="addLabel"
            :isShowAddLabel.sync="isShowAddLabel"
            :conditionList="conditionList"
            :columnList="columnList"
        ></add-label-dialog>

        <!-- 标签管理弹窗 -->
        <label-manage-dialog
            v-if="isShowLabelManage"
            ref="labelManage"
            :isShowLabelManage.sync="isShowLabelManage"
            @handleInitData="handleInitData"
        ></label-manage-dialog>
        <!-- 打印前选择发车单 -->
        <dispatch-modal
            v-if="dispatchModalVisible"
            :dispatchModalVisible.sync="dispatchModalVisible"
            :dispatchNoList="dispatchNoList"
            @openNewPrintDialog="openNewPrintDialog">
        </dispatch-modal>
        <!-- 新版打印窗口 -->
        <dispatch-new-print
            v-if="isShowNewPrintDialog"
            ref="dispatchNewPrint"
            :isShowNewPrintDialog.sync="isShowNewPrintDialog"
            :componentsData="checkedData"
            @openOldPrintDialog="openOldPrintDialog"
        ></dispatch-new-print>
        <!-- 旧版打印窗口 -->
        <dispatch-print
            v-if="isShowOldPrintDialog"
            ref="dispatchPrint"
            :isShowOldPrintDialog.sync="isShowOldPrintDialog"
            :componentsData="checkedData"
            @components-close="closeOldPrintDialog"
        ></dispatch-print>

        <dispatch-print-log
            v-if="isShowPrintLogDialog"
            ref="dispatchPrintLog"
            :isShowPrintLogDialog.sync="isShowPrintLogDialog"
            :componentsData="componentsData"
            :printOrder="componentsData.customerOrderNo"
        ></dispatch-print-log>

        <operation-node-log
            ref="operationNodeLog"
            v-if="isShowOperationNodeLog"
            :isShowOperationNodeLog.sync="isShowOperationNodeLog"
            :dictData="dictData"
            :taskNo="componentsData.taskNo"
            :componentsData="componentsData"
        ></operation-node-log>
    </paper>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import paper from '@/components/core/paper/Paper';
import mPane from '@/components/lots/VirtualPanel/index.vue';
import reportExport from '@/components/lots/reportExportPlugin';
import TransferCreate from './transferCreate/Index.vue';
import BindWaybill from './bindWaybill/Index';
import dispatchModal from './waybillPrint/dispatchModal';
import DispatchNewPrint from './waybillPrint/dispatchNewPrint/Index';
import DispatchPrint from '../dispatchOrderLists/dispatchPrint/Index.vue';
import AddLabelDialog from './../receiptCenter/labelManage/AddLabelDialog';
// 标签管理
import LabelManageDialog from './../receiptCenter/labelManage/labelManageDialog';
import OperationNodeLog from '../../distributeManage/dispatchMgmt/components/operationNodeLog/Index.vue';
import DispatchPrintLog from '../dispatchMgmt/components/dispatchPrintLog/Index';
import config from './config.js';
import { dictWithUrl } from '@/components/lots/api.js';
import {
    formatSearchData, validateSearchData, formatTotalDataList, validateBind,
    formatPrintData, formatSetSearchTime, formatLogList
} from './util';
import { queryWaybillOrderListLSP, queryCountLSP, getOtpLoadData, queryLogDetail  } from '@/modules/transport/otp/api/performanceWaybillManage';
import { queryTimeInterval } from '@/modules/transport/otp/api/performanceDispatchMgmt';
import getList from '@/components/awesome/page/mPanel3/api';
import bigDataLog from '@/utils/bigDataLog';
import { reveal, batchReveal } from '@/modules/transport/otp/utils/reveal';
import { sendRevealLogApi } from '@/modules/transport/otp/api/performanceReveal';
import { uniq } from 'lodash';

export default {
    name: 'waybillManage',
    components: {
        paper,
        mPane,
        reportExport,
        TransferCreate,
        BindWaybill,
        AddLabelDialog,
        LabelManageDialog,
        dispatchModal,
        DispatchNewPrint,
        OperationNodeLog,
        DispatchPrint,
        DispatchPrintLog
    },
    data () {
        return {
            config,
            timeRangeShortcuts: {
                shortcuts: [
                    { text: '今天', translate: '', today: true },
                    { type: 'd', num: 6, text: '最近一周', translate: '' },
                    { type: 'M', num: 1, text: '最近一个月', translate: '' },
                    { type: 'M', num: 2, text: '最近两个月', translate: '' }
                ]
            },
            isFirstSearch: true,
            pageTotal: 0,
            loading: false,
            selected: [], // 选中数据
            totalData: [], // 列表数据
            searchParams: {
                pageSize: 100,
                pageNo: 1,
                param: {}
            },
            exportParams: {},
            visiable: false,
            dictData: {}, // 数据字典集合
            columnList: '', // 当前列配置
            conditionList: '', // 当前查询条件
            transferDialogVisible: false,
            isShowAddLabel: false, // 是否显示新建标签弹窗
            isShowLabelManage: false, // 是否显示标签管理弹窗
            pullBtnLoading: false,
            bindLoading: false,
            bindDialogVisible: false,
            dispatchModalVisible: false,
            dispatchNoList: [],
            isShowNewPrintDialog: false,
            isShowOldPrintDialog: false,
            printLogDialogVisible: false,
            printLogList: [],
            isShowPrintLogDialog: false,
            isShowOperationNodeLog: false,
            componentsData: {},
            checkedData: {},
            maxSearchDay: 31, // 最大查询区间
            showEye: false // 是否显示整页解密眼睛
        };
    },
    computed: {
        ...mapGetters(['user']),
        ...mapState({
            supplier: state => state.supplier,
            currentTenant: state => state.currentTenant
        })
    },
    mounted () {
        this.getDicData();
        this.getMaxSearchLimit();
    },
    methods: {
        selectChange (data) {
            this.selected = data;
        },
        // 获取阿波罗配置的最大查询时间区间
        getMaxSearchLimit () {
            queryTimeInterval().then(res => {
                if (res && +res.code === 0) {
                    this.maxSearchDay = Number(res.data) || 31;
                }
            }).catch(() => { });
        },
        /**
         * @description 查询条件变化触发事件
         * @param {Object} data 查询条件
         */
        searchChange (data) {
            // 格式化查询条件
            const _searchData = formatSearchData(data);
            // 查询条件校验
            const isQueryOk = validateSearchData(_searchData, this.maxSearchDay);
            // 执行操作
            if (!isQueryOk) return;
            this.searchParams = this.getSearchData(_searchData);
            this.exportParams = { ...this.searchParams };
            this.getList();
            this.getListPageCount();
        },
        getSearchData (data) {
            const _searchData = {
                ...this.searchParams,
                param: {
                    ...data
                },
                pageNo: 1
            };
            for (const key in _searchData.param) {
                if (_searchData.param[key] === '') delete _searchData.param[key];
            }
            if (_searchData.param.defineStr1) {
                _searchData.param.kaType = 'OFC_JINGDONG';
            }
            return _searchData;
        },

        /**
         * @description 获取列表分页数据
         */
        getListPageCount () {
            const queryParams = {
                ...this.searchParams.param,
                carrierCodeList: [this.supplier.supplierCode] // 供应商编码-LSP
            };
            queryCountLSP(queryParams).then(res => {
                if (res && +res.code === 0) {
                    this.pageTotal = res.data || 0;
                }
            });
        },

        /**
         * @description 获取列表数据
         * @param {object} 查询条件
         * @return {list} 列表数据
         */
        async getList () {
            this.loading = true;
            this.searchParams.param.carrierCodeList = [this.supplier.supplierCode]; // 供应商编码-LSP
            queryWaybillOrderListLSP(this.searchParams)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.totalData = formatTotalDataList(res.data.list || [], this.dictData);
                        this.showEye = this.totalData.some(item => item.desensitizationFlag);
                    }
                })
                .finally(() => {
                    this.loading = false;
                    this.isFirstSearch = false;
                });
        },
        /**
         * @description 新建标签
         */
        handleAddLabel () {
            // 获取当前查询条件和列配置
            const searchData = this.$refs.tablePage.$refs.searchList.$refs.searchSet;
            const conditionList = {
                ...searchData[0].searchData,
                ...formatSetSearchTime(searchData[0].setSearchData)
            };
            this.conditionList = JSON.stringify(conditionList);
            this.columnList = JSON.stringify(this.$refs.tablePage.tableList);
            this.isShowAddLabel = true;
        },
        /**
         * @description 标签管理
         */
        handleLabelManage () {
            this.isShowLabelManage = true;
        },
        /**
         * @description 标签管理-应用回调函数
         * @params {Object} data 应用行数据
         */
        async handleInitData (data) {
            if (data.columnList) {
                const columnList = JSON.parse(data.columnList);
                // 表格应用
                this.$refs.tablePage.tableList = columnList;
                // 列配置应用
                const menu = { subResources: JSON.parse(JSON.stringify(this.menus)) };
                await this.deepMenu(menu);
                const configProps = columnList.split(',').map(item => {
                    if (this.config.table.columns.find(column => column.label === item)) {
                        return this.config.table.columns.find(column => column.label === item).prop;
                    }
                }).join(',');
                const params = {
                    'configName': configProps,
                    'configNameCn': columnList,
                    'subjectType': 'columnsConfig',
                    'moduleCode': this.resourceCode,
                    'id': this.user.employeeId
                };
                const key = `${params.id}-${params.subjectType}-${params.moduleCode}`;
                localStorage.setItem(key, JSON.stringify(params.configNameCn));
                getList.post(this.configurationUrl, params).then(() => { });
            }
            if (data.conditionList) {
                const setSearchData = this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].setSearchData;
                const searchData = this.$refs.tablePage.$refs.searchList.$refs.searchSet[0].searchData || {};
                const searchList = JSON.parse(data.conditionList);
                // 组装外层查询参数key值
                const outerSearchData = {
                    ...setSearchData
                };
                // 赋值前清空所有查询条件
                Object.keys(searchData).forEach(item => {
                    searchData[item] = null;
                });
                // 外层查询条件赋值（必须过滤，否则查询会携带高级查询参数）
                Object.keys(searchList).filter(v => outerSearchData.hasOwnProperty(v)).forEach(item => {
                    setSearchData[item] = searchList[item];
                });
                // 高级查询赋值
                Object.keys(searchList).forEach(item => {
                    searchData[item] = searchList[item];
                });
            }
        },
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const children = node.subResources;
                if (children) {
                    for (let i = 0; i < children.length; i++) {
                        if (children[i].frontUrl === this.$route.path) {
                            this.resourceCode = children[i].resourceCode;
                        } else {
                            this.deepMenu(children[i]);
                        }
                    }
                }
            }
        },
        pageChange (data) {
            this.searchParams.pageNo = data;
            this.getList();
        },
        sizeChange (data) {
            this.searchParams.pageSize = data;
            this.searchParams.pageNo = 1;
            this.getList();
        },
        // 双击事件
        rowDBclick (row) {
            this.$router.push({
                path: '/performance/waybill-detail',
                query: {
                    id: row.id,
                    taskNo: row.taskNo,
                    dispatchNo: row.dispatchNo
                }
            });
        },
        btnClick (val, index, rowData, prop) {
            if (prop === 'taskStatusName') {
                bigDataLog.sendDetailMessageByKey('bigData-btn-task-status');
                this.componentsData = rowData;
                this.isShowOperationNodeLog = true;
            }
        },
        handlePrint () {
            if (!this.selected.length) {
                return this.$message.warning('至少选择一条数据');
            }
            this.dispatchNoList = formatPrintData(this.selected);
            this.dispatchModalVisible = true;
        },
        openNewPrintDialog (data) {
            this.checkedData = data;
            this.isShowNewPrintDialog = true;
        },
        openOldPrintDialog () {
            this.$nextTick(() => {
                this.isShowOldPrintDialog = true;
            });
        },
        closeOldPrintDialog () {
            this.isShowOldPrintDialog = false;
        },
        printLog(rowData) {
            this.componentsData = rowData;
            this.isShowPrintLogDialog = true;
        },
        /**
         * @description 查看运单信息
         */
        viewWaybillDetail (row) {
            // this.$refs.performanceCommonDialog.show();
        },
        /**
        * @description 移交单创建
        */
        handleCreateTransferOrder () {
            const isOperateOk = this.isSelectedTransferOk(this.selected);
            if (!isOperateOk) return false;
            this.transferDialogVisible = true;
        },
        /**
         * @description 移交单创建逻辑判断： 1. 运输单状态为： 待移交， 批量操作需要校验状态且客户编码相同
         * @param {Array} selected 选中数据
         * @returns {Boolean}
         */
        isSelectedTransferOk (list) {
            if (!list.length) {
                this.$message.warning('请选择运输单');
                return false;
            }
            if (list.some(item => +item.taskStatus !== 70)) {
                this.$message.warning('请选择运输单状态为：待移交');
                return false;
            }
            // 判断是否客户编码相同
            const customerCodeList = list.map(k => k.customerCode);
            if (customerCodeList.some(k => k !== customerCodeList[0])) {
                this.$message.warning('多个运单客户编码必须相同');
                return false;
            }
            return true;
        },
        /**
         * @description 移交单创建弹框-关闭
         */
        handleClose () {
            this.transferDialogVisible = false;
            this.getList();
        },
        /**
         * @description 拉去OTP装货数据
         */
        pullOtpLoadingData () {
            const isOperateOk = this.validateSelectedData(this.selected);
            if (!isOperateOk) return false;
            this.pullBtnLoading = true;
            getOtpLoadData({
                transportId: this.selected[0].id
            })
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success(res.msg || '拉取OTP装货数据成功');
                        this.getList();
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.pullBtnLoading = false;
                });
        },
        /**
         * @description 拉去OTP装货数据单据状态判断: 只能操作单行数据， 且运输单状态为待倒车（10）
         * @param {Array} selected
         * @returns {Boolean}
         */
        validateSelectedData (list) {
            if (!list.length) {
                this.$message.warning('请选择运输单');
                return false;
            }
            if (list.length > 1) {
                this.$message.warning('请操作单条数据');
                return false;
            }

            const taskStatusList = list.map(k => k.taskStatus);
            if (taskStatusList.some(k => +k !== 20)) {
                this.$message.warning('请选择运输单状态为：待装车状态');
                return false;
            }
            return true;
        },
        /**
         * @description 绑定零担运单号
         */
        bindLdWaybillNo () {
            const isOk = validateBind(this.selected);
            if (!isOk) return false;
            this.bindDialogVisible = true;
        },
        /**
         * @description 绑定零担运单号弹框-关闭
         */
        handleCloseBindDialog () {
            this.bindDialogVisible = false;
            this.getList();
        },
        /**
         * @description 查看轨迹按钮，跳转至运单地图监控
         * @param {Object} 当前行数据
        */
        viewTrack (row) {
            this.$router.push({
                path: '/performance/waybill-map-monitor',
                query: {
                    taskNo: row.taskNo
                }
            });
        },
        /**
         * @descripttion 导出
         */
        exportFile (submit) {
            const doSubmit = () => {
                submit({
                    ...this.exportParams.param,
                    tenantCode: this.currentTenant.tenantCode,
                    beginDate: this.exportParams.param.createTimeStart,
                    endDate: this.exportParams.param.createTimeEnd,
                    requestResults: this.$refs.tablePage.tableList
                });
            };
            // 第一次点导出时触发查询函数，之后的导出以前一次的查询条件为准
            this.isFirstSearch && this.$refs.tablePage.$refs.searchList.onSearchChange();
            doSubmit();
        },
        /**
         * @description 获取数据字典:
         * 发运类型: TMS_SHIPPING_TYPE
         * 任务类型: TASK_TYPE
         * 出入库类型: IN_OUT_TYPE
         * 订单类型: ORDER_TYPE
         * 订单来源平台： ORDER_SOURCE_PLATFORM
         * 来源系统: SOURCE_SYSTEM
         * 业务模式: BUSINESS_MODE
         * 项目分类: PROJECT_CLASSIFY
         * 是否模糊订单: PLAN_ORDER_FLAG
         * 业务大类: BUSINESS_CATEGORY
         * 运费类型: DELIVERYPAY_TYPE
         * 是否代收: COLLECTION_FLAG
         * WMS状态: WMS_STATUS
         * 是否扫码: SCAN_FLAG
         * 是否提供装卸服务: HANDLING_STATUS
         * 是否分拨订单: DISTRIBUTION_FLAG
         * 是否最后一次分拨: DISTRIBUTION_LAST_FLAG
         * 配送方式: DELIVERY_TYPE
         * 采购渠道: OTP_TMS_PROCUREMENT_CHANNEL
         * 签收类型: DELIVERED_VERIFY_FLAG
         * 运输单状态: TRANSPORT_STATUS
         * 是否可见: CARRIER_VISIBLE_FLAG
         * 是否下发零担平台: IS_ISSUE
         * 专业公司: SYS_PROFESSIONAL_COMPANY
         * @param {string} 数据字典编码字符串
         * @return {Object} 数据字典类型集合
         *
         */
        async getDicData () {
            /* eslint-disable max-len */
            const dict = await dictWithUrl(
                'TMS_SHIPPING_TYPE,TASK_TYPE,IN_OUT_TYPE,ORDER_TYPE,ORDER_SOURCE_PLATFORM,SOURCE_SYSTEM,BUSINESS_MODE,PROJECT_CLASSIFY,PLAN_ORDER_FLAG,BUSINESS_CATEGORY,DELIVERYPAY_TYPE,COLLECTION_FLAG,WMS_STATUS,SCAN_FLAG,HANDLING_STATUS,DISTRIBUTION_FLAG,DISTRIBUTION_LAST_FLAG,DELIVERY_TYPE,OTP_TMS_PROCUREMENT_CHANNEL,DELIVERED_VERIFY_FLAG,TRANSPORT_STATUS,CARRIER_VISIBLE_FLAG,IS_ISSUE,SYS_PROFESSIONAL_COMPANY,TRANSPORTATION_DIVISION_TYPE,REPEAT_PRINT_REASON,TMS_OPERATION_NODE,OPERATION_LOG_ATTACHMENT_TYPE'
            );
            this.dictData = dict.data;
        },
        /**
         * 行脱敏数据回显:
         * 1、当行解密
         * 2、相同行解密：收货人姓名+收货人手机+收货详细地址, 以上述三组信息作为判定依据，只要匹配到三组信息一致的，则解密该行数据
         *  */
        onReveal(row) {
            const compareKeys = ['receiverNameEncrypted', 'receiverMobileEncrypted', 'receiverDetailAddrEncrypted'];
            reveal(row, this.config).radiate(this.totalData, compareKeys).done(donedArr => {
                if (donedArr) {
                    this.totalData = [].concat(this.totalData); // 触发表格更新
                    this.sendRevealLog(donedArr);
                }
            });
        },
        // 整页脱敏数据回显
        onRevealAll() {
            batchReveal(this.totalData, this.config).done(donedArr => {
                if (donedArr) {
                    this.totalData = [].concat(this.totalData); // 触发表格更新
                    this.sendRevealLog(donedArr);
                }
            });
        },
        // 发送解密日志
        sendRevealLog(rows) {
            if (rows && rows.length) {
                return sendRevealLogApi({
                    orderNos: uniq(rows.map(item => item.dispatchNo)),
                    pageCode: 'EL-TRANSPORT' // EL-运单管理：EL-TRANSPORT
                });
            }
        }
    }
};
</script>
